<div class="crm-container">
  <app-section-header [title]="title" />
  <div class="sub-section" [class.is-loading]="isLoading">
    <div class="view-file-spinner" *ngIf="isLoading">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div class="spinner-download" *ngIf="downloadingSpinner">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <p-table styleClass="p-datatable-gridlines" [columns]="cols" [value]="dataList" dataKey="id" [scrollable]="true"
      editMode="row" [hidden]="isLoading">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing" let-ri="rowIndex">
        <tr>
          <td *ngFor="let col of cols" [class.action-cell]="col.field === 'action'">
            <div *ngIf="col.field === 'action'" class="action-buttons">
              <button
                *ngFor="let option of ellipsisOptions"
                type="button"
                class="action-btn"
                [class.action-btn-delete]="option.value === 'delete'"
                (click)="onActionClick($event, rowData, option)">
                {{ option.label }}
              </button>
            </div>
            <ng-container *ngIf="col.field !== 'action'">{{ rowData[col.field] }}</ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-toast></p-toast>
<div
  class="view-file-failure-mask"
  *ngIf="openFailureVisible"
  role="presentation"
  (mousedown)="$event.preventDefault(); $event.stopPropagation()"
  (click)="$event.stopPropagation()">
  <div
    class="view-file-failure-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-label="Failed"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <div class="view-file-failure-header">
      <span>Failed</span>
      <button
        type="button"
        class="view-file-failure-close"
        aria-label="Close"
        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
        (click)="dismissFailureDialog($event)">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="view-file-failure-body">
      <span class="view-file-failure-icon" aria-hidden="true">
        <i class="pi pi-exclamation-triangle"></i>
      </span>
      <div class="view-file-failure-text">
        <p>{{ openFailureMessage }}</p>
        <ul class="view-file-failure-steps">
          <li *ngFor="let step of openFailureSteps">{{ step }}</li>
        </ul>
      </div>
    </div>
    <div class="view-file-failure-footer">
      <button
        type="button"
        class="view-file-failure-ok"
        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
        (click)="dismissFailureDialog($event)">
        OK
      </button>
    </div>
  </div>
</div>